/* QUIETUDE — rotating avatar queue.
   Only rewrites --rank and the seated flag; the slide, fade and scale are
   CSS transitions. Held still for prefers-reduced-motion, and paused when
   the row is off-screen so it costs nothing while nobody is looking. */
(function () {
  if (window.__qtTrustBound) return;
  window.__qtTrustBound = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(scope) {
    (scope || document).querySelectorAll('[data-avatars]').forEach(function (row) {
      if (row.dataset.bound) return;
      row.dataset.bound = '1';

      var faces = [].slice.call(row.querySelectorAll('.mm-av'));
      var seats = parseInt(row.getAttribute('data-seats') || '3', 10);
      var every = parseInt(row.getAttribute('data-every') || '2000', 10);

      /* Nothing to rotate when every avatar already has a seat. */
      if (faces.length <= seats || reduced || every < 400) return;

      var start = 0;

      function place() {
        faces.forEach(function (face, i) {
          var rank = (i - start + faces.length) % faces.length;
          if (rank < seats) {
            face.style.setProperty('--rank', rank);
            face.classList.add('is-seated');
          } else {
            /* The next one waits one pitch to the right; everyone else is
               parked one pitch to the left, which is where a leaving avatar
               travels to. */
            face.style.setProperty('--rank', rank === seats ? seats : -1);
            face.classList.remove('is-seated');
          }
        });
      }

      var timer = null;
      function play() {
        if (timer) return;
        timer = setInterval(function () {
          start = (start + 1) % faces.length;
          place();
        }, every);
      }
      function pause() {
        if (!timer) return;
        clearInterval(timer);
        timer = null;
      }

      place();

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries[0].isIntersecting ? play() : pause();
        }, { threshold: 0.2 }).observe(row);
      } else {
        play();
      }

      document.addEventListener('visibilitychange', function () {
        document.hidden ? pause() : play();
      });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();